// extracted by mini-css-extract-plugin
export default {"impressionPixel":"cpm-profile-sponsorship-pixels-impressionPixels__impressionPixel--1nZvh"};